// src/utils/passwordValidator.js
const passwordRules = {
    isLengthy: (pw) => pw.length >= 8,
    hasUpper: (pw) => /[A-Z]/.test(pw),
    hasLower: (pw) => /[a-z]/.test(pw),
    hasNumber: (pw) => /[0-9]/.test(pw),
    hasSpecialChar: (pw) => /[!,@,#,$,%,&]/.test(pw),
  };
  
  const validatePassword = (password) => {
    return {
      isLengthy: passwordRules.isLengthy(password),
      hasUpper: passwordRules.hasUpper(password),
      hasLower: passwordRules.hasLower(password),
      hasNumber: passwordRules.hasNumber(password),
      hasSpecialChar: passwordRules.hasSpecialChar(password),
    };
  };
  
export { passwordRules, validatePassword };  